// Dependencies
import { useTranslation } from 'react-i18next';
import { Route, Switch } from 'react-router-dom';

// Components
import OrderHeader from '../OrderHeader';
import LastFooter from '../LastFooter';
import ContractUS from '../Consultancy/ContractUS';

// Styles
import styles from './index.module.sass';

export default function Order({
  history,
  match,
  getCookie,
  webservice,
  device,
  setSessionMessage,
  screenSize,
}) {
  const { t } = useTranslation('order');

  function handleClose() {
    history.push('/');
  }

  return (
    <div className={`${styles.contract}`}>
      <OrderHeader />
      <div className={styles.orderHeader}>
        <div className={styles.return} onClick={handleClose}>
          <i className='material-icons-outlined'>navigate_before</i>
          <span className={styles.returnText}>{t('return')}</span>
        </div>
      </div>
      <div className={styles.contractContainer}>
        <Switch>
          <Route
            exact
            path={`${match.path}/newcontractus`}
            render={(props) => {
              return (
                <ContractUS
                  history={history}
                  match={match}
                  getCookie={getCookie}
                  webservice={webservice}
                  device={device}
                  setSessionMessage={setSessionMessage}
                  typecontract='independentus'
                />
              );
            }}
          />

          <Route
            exact
            path={`${match.path}/prefilledcontractus/:tokencontract?`}
            render={(props) => {
              return (
                <ContractUS
                  history={history}
                  match={match}
                  getCookie={getCookie}
                  webservice={webservice}
                  device={device}
                  setSessionMessage={setSessionMessage}
                  typecontract='prefilledcontractus'
                />
              );
            }}
          />
        </Switch>
      </div>

      <LastFooter screenSize={screenSize} />
    </div>
  );
}
